import { all, put, takeEvery } from "redux-saga/effects";
import { fetcher, getErrorMsg, handleError } from "lib/fetch";
import * as actions from "./actions";

const url = "saleorders";

function* loadCloseWork(action) {
  try {
    const { params, token } = action.payload;
    const res = yield fetcher.post(url, params, token);
    yield put(actions.loadCloseWork.success(res.data));
  } catch (error) {
    handleError(error);
    yield put(actions.loadCloseWork.failure(getErrorMsg(error)));
  }
}


export default function* watchClosewordState() {
  yield all([
    takeEvery(actions.LOAD_CLOSE_WORK.REQUEST, loadCloseWork),
  ]);
}
